// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__13yMr","choiceBoxes":"toolbarselects_choiceBoxes__3Zv8R","simpleField":"toolbarselects_simpleField__1MAu8"};